import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Boir = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">BOIR</h1>
            <Link to="/services" className="tax-notification-body">← Back to Services</Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Beneficial Ownership Information Report (BOIR) Services at Litax
          </h1>
          <p className='tax-section-description'>
            The Financial Crimes Enforcement Network (FinCEN) has introduced the Beneficial Ownership Information Report (BOIR) to improve transparency and prevent financial crimes. Filing the BOIR correctly is crucial for businesses, and Litax. is here to guide you every step of the way.
          </p>

          <h2 className='tax-subheading'>What is the BOIR?</h2>
          <p className='tax-section-description'>
            The BOIR requires certain entities, including corporations and LLCs, to disclose detailed information about their beneficial owners. Beneficial owners are individuals who directly or indirectly own or control a significant portion of the entity or exercise substantial influence over its operations. This measure helps combat money laundering, tax evasion, and other illicit activities.
          </p>

          <h2 className='tax-subheading'>Why Partner with Litax.?</h2>
          <ul className='tax-section-description'>
            <li><strong>Expert Guidance:</strong> Our CPAs and EAs are well-versed in BOIR regulations and FinCEN compliance requirements.</li>
            <li><strong>Customized Solutions:</strong> Each business is unique. We tailor our services to your ownership structure and reporting needs.</li>
            <li><strong>Full-Service Support:</strong> From data collection to filing and ongoing compliance, we handle the entire process for you.</li>
            <li><strong>Accuracy & Timeliness:</strong> Avoid costly penalties and ensure filings are completed on time with our meticulous review process.</li>
          </ul>

          <h2 className='tax-subheading'>Our BOIR Services</h2>
          <p className='tax-section-description'>
            At Litax., we provide comprehensive services to make BOIR compliance effortless:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Assessment & Eligibility:</strong> Determine if your entity is required to file and understand the reporting thresholds.</li>
            <li><strong>Data Collection & Verification:</strong> Gather and verify information on all beneficial owners, including names, addresses, ownership percentages, and control details.</li>
            <li><strong>Report Preparation:</strong> Accurately complete the BOIR with validated data reflecting your current ownership structure.</li>
            <li><strong>Filing & Submission:</strong> Submit the BOIR to FinCEN on your behalf, ensuring all deadlines are met.</li>
            <li><strong>Ongoing Compliance Monitoring:</strong> Track changes in ownership and ensure updated filings are submitted as required.</li>
            <li><strong>Regulatory Consulting:</strong> Advise on best practices, internal controls, and compliance strategies to maintain transparency and mitigate risk.</li>
            <li><strong>Audit Support:</strong> Represent and assist your business in case of regulatory inquiries or BOIR-related audits.</li>
          </ol>

          <h2 className='tax-subheading'>Benefits of Working with Us</h2>
          <ul className='tax-section-description'>
            <li>Ensure complete compliance with FinCEN regulations.</li>
            <li>Minimize risks associated with incorrect or late reporting.</li>
            <li>Streamline internal processes for gathering ownership data.</li>
            <li>Gain confidence that your business meets transparency requirements.</li>
          </ul>

          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            BOIR compliance can be complex, but with Litax., you have a reliable partner. Our team of CPAs and EAs will ensure your beneficial ownership information is accurately reported and up-to-date. Contact us today to schedule a consultation and secure peace of mind for your business.
          </p>
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Boir;
